import React, { FC, ReactNode, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { paginationStorage } from '../../storage/local-storage/pagination-storage.util';
import { prevPageStorage } from '../../storage/local-storage/prev-page-storage.util';
import HeaderLayout from '../header-layout/index';
import SideBarLayout from '../side-bar-layout/index';

export type AppLayoutProps = {
  children: ReactNode;
  className?: string;
};
export const useRegisterPageChange = () => {
  const { pathname } = useLocation();
  const prefPage = useRef(prevPageStorage.get());

  if (prefPage.current !== pathname) {
    prefPage.current = pathname;
    prevPageStorage.set(pathname);
    paginationStorage.delete();
  }
};
const AppLayout: FC<AppLayoutProps> = ({ children, className }) => {
  useRegisterPageChange();
  return (
    <>
      <SideBarLayout>
        <HeaderLayout className={className}>{children}</HeaderLayout>
      </SideBarLayout>
    </>
  );
};

AppLayout.displayName = 'AppLayout';

export default AppLayout;
